'use strict';

import request from 'superagent';
import api from './core';

export function geocode(address) {
    return new Promise((resolve, reject) => {
        api.prepare(request.get(api.url('/geocode/'))).query({address}).end((err, res) => {
            if (err || !res.body || !res.body.results) {
                reject('Impossible d\'obtenir la liste des propositions');
            }

            resolve(res.body.results);
        });
    });
}



// WEBPACK FOOTER //
// ./src/api/geocoding.js